import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const SvgMessages = (props: SvgProps) => (
  <Svg width="1em" height="1em" viewBox="0 0 90 63" fill="none" {...props}>
    <g>
      <g filter="url(#filter1_ii_1778_28539)">
        <path
          d="M83.0541 22.377H32.8082C29.0103 22.377 25.9312 25.4632 25.9312 29.2699V50.6989C25.9312 54.5061 29.0103 57.5918 32.8082 57.5918H76.6975L79.2358 61.9986C79.6524 62.7217 80.6937 62.7217 81.1102 61.9986L83.6646 57.5641C87.1763 57.254 89.9312 54.299 89.9312 50.6983V29.2699C89.9312 25.4632 86.852 22.377 83.0541 22.377Z"
          fill="url(#paint0_linear_1778_28539)"
        />
      </g>
      <g filter="url(#filter2_di_1778_28539)">
        <circle cx="43.9469" cy="39.0231" r="2.47228" fill="#F5FAD9" />
      </g>
      <g filter="url(#filter3_di_1778_28539)">
        <circle cx="57.7911" cy="39.0231" r="2.47228" fill="#F5FAD9" />
      </g>
      <g filter="url(#filter4_di_1778_28539)">
        <circle cx="71.6363" cy="39.0231" r="2.47228" fill="#F5FAD9" />
      </g>
    </g>
    <g>
      <g filter="url(#filter6_ii_1778_28539)">
        <path
          d="M6.23283 0.458984H51.2696C54.6737 0.458984 57.4336 3.22529 57.4336 6.63728V25.8446C57.4336 29.2571 54.6737 32.0229 51.2696 32.0229H11.9304L9.65526 35.9729C9.28192 36.621 8.34858 36.621 7.97524 35.9729L5.6857 31.9981C2.53808 31.7202 0.0687904 29.0715 0.0687904 25.8441V6.63728C0.0687904 3.22529 2.82872 0.458984 6.23283 0.458984Z"
          fill="url(#paint1_linear_1778_28539)"
        />
      </g>
      <g filter="url(#filter7_di_1778_28539)">
        <circle
          cx="2.21596"
          cy="2.21596"
          r="2.21596"
          transform="matrix(-1 0 0 1 43.5015 13.1641)"
          fill="white"
        />
      </g>
      <g filter="url(#filter8_di_1778_28539)">
        <circle
          cx="2.21596"
          cy="2.21596"
          r="2.21596"
          transform="matrix(-1 0 0 1 31.0928 13.1641)"
          fill="white"
        />
      </g>
      <g filter="url(#filter9_di_1778_28539)">
        <circle
          cx="2.21596"
          cy="2.21596"
          r="2.21596"
          transform="matrix(-1 0 0 1 18.6831 13.1641)"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_n_1778_28539"
        x="25.9312"
        y="22.377"
        width="64"
        height="40.1641"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="2.0307102203369141 2.0307102203369141"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="8988"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(245, 250, 217, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_1778_28539">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_ii_1778_28539"
        x="21.4992"
        y="16.5169"
        width="72.8639"
        height="48.9787"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4.43195" dy="2.95463" />
        <feGaussianBlur stdDeviation="4.75203" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.0980392 0 0 0 0 0.431373 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1778_28539"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4.43195" dy="-5.90926" />
        <feGaussianBlur stdDeviation="2.93001" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.701961 0 0 0 0 0.764706 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_1778_28539"
          result="effect2_innerShadow_1778_28539"
        />
      </filter>
      <filter
        id="filter2_di_1778_28539"
        x="39.5049"
        y="36.5508"
        width="8.88384"
        height="8.88384"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.96975" />
        <feGaussianBlur stdDeviation="0.984877" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.0980392 0 0 0 0 0.431373 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1778_28539"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1778_28539"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.96975" />
        <feGaussianBlur stdDeviation="0.984877" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.701961 0 0 0 0 0.764706 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_1778_28539"
        />
      </filter>
      <filter
        id="filter3_di_1778_28539"
        x="53.3491"
        y="36.5508"
        width="8.88384"
        height="8.88384"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.96975" />
        <feGaussianBlur stdDeviation="0.984877" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.0980392 0 0 0 0 0.431373 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1778_28539"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1778_28539"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.96975" />
        <feGaussianBlur stdDeviation="0.984877" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.701961 0 0 0 0 0.764706 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_1778_28539"
        />
      </filter>
      <filter
        id="filter4_di_1778_28539"
        x="67.1943"
        y="36.5508"
        width="8.88384"
        height="8.88384"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.96975" />
        <feGaussianBlur stdDeviation="0.984877" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.0980392 0 0 0 0 0.431373 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1778_28539"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1778_28539"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.96975" />
        <feGaussianBlur stdDeviation="0.984877" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.701961 0 0 0 0 0.764706 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_1778_28539"
        />
      </filter>
      <filter
        id="filter5_n_1778_28539"
        x="0.0688477"
        y="0.458984"
        width="57.3647"
        height="36"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="2.2655956745147705 2.2655956745147705"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="8988"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(245, 250, 217, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_1778_28539">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter6_ii_1778_28539"
        x="-3.90362"
        y="-4.7935"
        width="65.3097"
        height="43.9008"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-3.97247" dy="2.64831" />
        <feGaussianBlur stdDeviation="4.25937" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.960784 0 0 0 0 0.980392 0 0 0 0 0.85098 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1778_28539"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3.97247" dy="-5.29662" />
        <feGaussianBlur stdDeviation="2.62624" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.996078 0 0 0 0 0.737255 0 0 0 0 0.180392 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_1778_28539"
          result="effect2_innerShadow_1778_28539"
        />
      </filter>
      <filter
        id="filter7_di_1778_28539"
        x="37.3038"
        y="13.1641"
        width="7.96321"
        height="7.96272"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.76554" />
        <feGaussianBlur stdDeviation="0.88277" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.996078 0 0 0 0 0.737255 0 0 0 0 0.180392 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1778_28539"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1778_28539"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.76554" />
        <feGaussianBlur stdDeviation="0.88277" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.501961 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_1778_28539"
        />
      </filter>
      <filter
        id="filter8_di_1778_28539"
        x="24.8951"
        y="13.1641"
        width="7.96321"
        height="7.96272"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.76554" />
        <feGaussianBlur stdDeviation="0.88277" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.996078 0 0 0 0 0.737255 0 0 0 0 0.180392 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1778_28539"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1778_28539"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.76554" />
        <feGaussianBlur stdDeviation="0.88277" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.501961 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_1778_28539"
        />
      </filter>
      <filter
        id="filter9_di_1778_28539"
        x="12.4854"
        y="13.1641"
        width="7.96321"
        height="7.96272"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.76554" />
        <feGaussianBlur stdDeviation="0.88277" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.996078 0 0 0 0 0.737255 0 0 0 0 0.180392 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1778_28539"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1778_28539"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.76554" />
        <feGaussianBlur stdDeviation="0.984877" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.501961 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_1778_28539"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1778_28539"
        x1="89.9312"
        y1="24.6844"
        x2="37.0245"
        y2="56.1647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB3C3" />
        <stop offset="1" stopColor="#EF196E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1778_28539"
        x1="0.0687338"
        y1="2.52722"
        x2="47.4903"
        y2="30.7438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEB80" />
        <stop offset="1" stopColor="#FEBC2E" />
      </linearGradient>
    </defs>
  </Svg>
);

export default SvgMessages;
